export default __webpack_public_path__ + "static/media/chat-1.9db4f544.JPG";